import React, { FC } from 'react';
import classNames from 'classnames';
import styles from '../../assets/simple-table.module.scss';
import Dotdotdot from 'react-dotdotdot';

interface Props {
    columns: { id: string; type?: string; cellStyle: string }[];
    colorColumn?: string;
    //row: { [key: string]: any };
    row: any;
}

const SimpleTable: FC<Props> = ({ columns, row, colorColumn }: Props) => {
    if (!row) {
        return null;
    }
    return (
        <tr className={classNames(styles[`${colorColumn}`])}>
            {columns.map((column: { id: string; type?: string; cellStyle: string }, key) => {
                return (
                    <td className={classNames(styles[column.cellStyle])} key={`td-${key}`}>
                        <Dotdotdot clamp={4} key={`td-${key}`} className={classNames(styles[column.cellStyle])}>
                            {row[`${column?.id}`]}
                        </Dotdotdot>
                    </td>
                );
            })}
        </tr>
    );
};

export default SimpleTable;
